import React from "react"
import CaseDetailRedirect from "../../components/CaseDetailRedirect"
import CaseListEnhanced from "../../components/CaseList/CaseListEnhanced"

const Cases = () => {
  return (
    <CaseListEnhanced onRowClickComponent={CaseDetailRedirect} timeout={500} />
  )
}

export default Cases
